import * as React from 'react';

const PlayIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      fill="currentColor"
      className={props.className}
      d="M19.162 13.824c1.234-.686 1.234-2.461 0-3.147L8.468 4.736c-1.2-.667-2.674.201-2.674 1.573v11.882c0 1.373 1.474 2.24 2.674 1.574z"
    ></path>
  </svg>
);

export default PlayIcon;
